module.exports = __webpack_public_path__ + "static/media/forward.d0cbef9d.svg";